import { useLocation, useParams } from 'react-router-dom';
import useTheme from 'chat-ui/src/hooks/useTheme';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import UserIconDropDown from './UserIconDropDown';
import Routes from '@/router/routes';
import useTranslation from '@/hooks/useTranslation';
import ProjectButtonScenarios from './ProjectButtonScenarios';
import { ECompanyThemeName, EProjectStatus } from '@/enums';
import useGetCurrentWorkspace from '@/hooks/useGetCurrentWorkspace';
import useResultTabStore from '@/store/ResultsTabStore';
import { NavProps } from '@/types';
import WorkspaceName from '@/components/Navbar/WorkspaceName';
import NavBarLinks from '@/components/Navbar/NavBarLinks';
import { useCurrentProject } from '@/hooks/useCurrentProject';

function ProjectNavbar({ isSubscribed, organizationFirstLetter }: NavProps) {
  const location = useLocation();
  const {
    project_id: projectId,
    workspace_id: workspaceId,
    organization_id: organizationId,
  } = useParams();
  const { lang } = useTranslation();
  const { currentTheme, themeName } = useTheme();
  const currentWorkspace = useGetCurrentWorkspace();
  const { name: workspaceName } = currentWorkspace || {};
  const { resetTabs } = useResultTabStore();
  const { currentProject: singleProjectData } = useCurrentProject();
  const isProjectDraft = singleProjectData?.status === EProjectStatus.DRAFT;
  const isDefaultTheme = themeName === ECompanyThemeName.DEFAULT;
  const isEmpathyTheme = themeName === ECompanyThemeName.EMPATHY;
  const projectStatus = singleProjectData?.status;
  const projectTitle = singleProjectData?.title;

  return (
    <nav
      style={{ backgroundColor: currentTheme?.background }}
      className="fixed left-0 right-0 flex h-[55px] items-center z-100 justify-between max-w-full gap-5 px-[2%] py-2 transition-all ease-in border-b"
    >
      <div className="flex items-center gap-2 text-[15px] w-fit whitespace-nowrap">
        <Avatar className="object-cover h-full -mr-2.5">
          {/* add img later */}
          <AvatarImage src="" className="object-cover max-w-[25px] max-h-[25px]" />
          <AvatarFallback
            style={{ backgroundColor: currentTheme?.['chat-primary'] }}
            className="h-7 w-7 font-semibold py-0.5 text-white"
          >
            {organizationFirstLetter}
          </AvatarFallback>
        </Avatar>

        {projectTitle && workspaceName && (
          <WorkspaceName
            projectTitle={projectTitle}
            workspaceName={workspaceName}
            routes={Routes}
            organizationId={organizationId}
            workspaceId={workspaceId}
            resetTabs={resetTabs}
          />
        )}
      </div>
      <NavBarLinks
        resetTabs={resetTabs}
        organizationId={organizationId}
        workspaceId={workspaceId}
        projectId={projectId}
        lang={lang}
        routes={Routes}
        location={location}
        projectStatus={projectStatus}
        isEmpathyTheme={isEmpathyTheme}
      />

      <div className="flex items-center justify-end gap-4 w-fit">
        {isProjectDraft && !isSubscribed && isDefaultTheme && (
          <a
            className="px-4 py-1.5 text-sm font-semibold text-white rounded-md bg-chat-primary hover:scale-[1.02] transition-all ease-in-out hover:bg-[#ed638a]"
            href="https://tellet.ai/demo"
            target="_blank"
            rel="noreferrer"
          >
            {lang.get('msg.upgradeNow')}
          </a>
        )}

        <ProjectButtonScenarios />

        {/* user profile */}
        <button type="button" aria-label="user profile">
          <UserIconDropDown />
        </button>
      </div>
    </nav>
  );
}

export default ProjectNavbar;
